import { getModelProvider } from '@/lib/utils'

interface ModelBadgeProps {
  modelName: string
  displayName?: string
  className?: string
}

const providerConfig = {
  openai: {
    label: 'OpenAI',
    dotClass: 'bg-green-500',
    bgClass: 'bg-green-50 text-green-700 border-green-200',
  },
  anthropic: {
    label: 'Anthropic',
    dotClass: 'bg-orange-500',
    bgClass: 'bg-orange-50 text-orange-700 border-orange-200',
  },
  unknown: {
    label: 'LLM',
    dotClass: 'bg-gray-400',
    bgClass: 'bg-gray-50 text-gray-600 border-gray-200',
  },
} as const

export function ModelBadge({ modelName, displayName, className = '' }: ModelBadgeProps) {
  const provider = getModelProvider(modelName)
  const config = providerConfig[provider]
  const label = displayName || modelName

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs font-medium ${config.bgClass} ${className}`}
      title={`${config.label} - ${modelName}`}
    >
      <span className={`inline-block h-2 w-2 rounded-full ${config.dotClass}`} />
      {label}
    </span>
  )
}

export function ModelProviderDot({ modelName, className = '' }: { modelName: string; className?: string }) {
  const provider = getModelProvider(modelName)
  const config = providerConfig[provider]

  return (
    <span
      className={`inline-block h-2 w-2 rounded-full ${config.dotClass} ${className}`}
      title={config.label}
    />
  )
}
